import React from 'react';

import Header from '@components/ApplicationHeader';

import { Container, Content } from './style';

const DefaultLayout = ({ children }) => (
  <Container>
    <Header />
    <Content>{children}</Content>
  </Container>
);

export default DefaultLayout;
